import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const ChannelPage = lazy(() => import('../modules/accounts/ChannelSettings'))
  const ChatbotSettingsPage = lazy(() => import('../modules/accounts/ChatbotSettings'))
  const ChannelSettingsModuleFake = lazy(() => import('../modules/accounts/ChannelSettingsModuleFake'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const ArtificialIntelligencePage = lazy(() => import('../modules/apps/artificial-intelligence/ArtificialIntelligencePage'))
  const TokensPage = lazy(() => import('../modules/apps/artificial-intelligence/TokensPage'))
  const TagsPage = lazy(() => import('../modules/apps/artificial-intelligence/TagsPage'))
  const SubjectsPage = lazy(() => import('../modules/apps/artificial-intelligence/SubjectsPage'))
  const SubjectGroupsPage = lazy(() => import('../modules/apps/artificial-intelligence/SubjectGroupsPage'))
  const RestrictionsPage = lazy(() => import('../modules/apps/artificial-intelligence/RestrictionsPage'))
  const MessagingPage = lazy(() => import('../modules/apps/messaging/MessagingPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/channels'
          element={
            <SuspensedView>
              <ChannelPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/chatbot-settings'
          element={
            <SuspensedView>
              <ChatbotSettingsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/channelsFake'
          element={
            <SuspensedView>
              <ChannelSettingsModuleFake />
            </SuspensedView>
          }
        />
        <Route
          path='apps/messaging/*'
          element={
            <SuspensedView>
              <MessagingPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/artificial-intelligence/*'
          element={
            <SuspensedView>
              <ArtificialIntelligencePage />
              <RestrictionsPage />
              <TagsPage />
              <TokensPage />
              <SubjectsPage />
              <SubjectGroupsPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
